<!--<div class="modal-content">-->
<div class="modal-header">
  <h4 class="modal-title"><i class="fas fa-cog"></i> {{ "TITLE.IMAGE-PROPERTIES" | translate }}</h4>
</div>
<div class="modal-body">
  <div class="row">
    <div class="padding-select-file col-md-8">
      <label class="font-weight-bold mb-0">{{"PALETTE.IMAGE" | translate}}</label>
      <div class="custom-file content-file">
        <input type="file" class="custom-file-input w-100 content-file" accept="image/*"
               id="customFile" (change)="changeStatus($event)">
        <label class="custom-file-label"
               for="customFile">
          {{imageProperty.fileName ? imageProperty.fileName : "MESSAGE.SELECT" | translate }}
        </label>
      </div>
    </div>
    <div class="col-md-4 mt-2">
      <label class="font-weight-bold mb-0">{{"BUTTON.PREVIEW" | translate}}</label>
      <img [src]="imageProperty.src ? imageProperty.src: '../../../../../assets/image/image-default.jpg'"
           alt="Image by default" class="custom-image-container">
    </div>
  </div>
  <div>
    <label class="font-weight-bold mb-0">{{"LABEL.WIDTH" | translate}}</label>
    <input class="form-control" [(ngModel)]="imageProperty.width" placeholder="Ingrese el ancho de la imagen en px">
  </div>
  <div>
    <label class="font-weight-bold mb-0">{{"LABEL.HEIGHT" | translate}}</label>
    <input class="form-control" [(ngModel)]="imageProperty.height" placeholder="Ingrese la altura de la imagen en px">
  </div>

</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-success"
          (click)="accept()"><i class="fas fa-exchange-alt"></i> {{ "BUTTON.APPLY-CHANGE" | translate }}</button>
</div>

